export default "__VITE_ASSET__$W$vCus3__"